module.exports = __webpack_public_path__ + "static/media/node.d9e13b7f.PNG";